export default __webpack_public_path__ + "static/media/activemq.963f422755383a277eb0ccf3e89bf66b.svg";